export const PARENT_NODE_ID = 'img_parent'
export const IMAGE_NODE_ID = 'img_content'
